import Loading from 'components/commons/contextual/Loading';
import { subShowSubMenuState } from 'redux/slices/subMenuSlices';
import { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Precarga from 'screens/precarga/Precarga';
import NavBar from 'components/features/navBar/NavBar';
import Footer from 'components/widgets/footer/Footer';
import { useTheme } from 'context/themeContext';
import LeftMenu from 'screens/exploreScreen/components/leftMenu/LeftMenu';
import { useSelector } from 'react-redux';
import SubMenu from 'components/features/navBar/submenu/SubMenu';
import { useLanguage } from 'context/languageContext';
import Router from 'routes';
import PriorityMessageAlert from 'components/features/priorityMessageAlert/PriorityMessageAlert';

export default function App() {
  const currentLanguage = useLanguage();
  const showSubMenuSelector = useSelector(subShowSubMenuState);
  const theme = useTheme();

  // Estado para saber si la precarga ha finalizado
  const [precargaLoaded, setPrecargaLoaded] = useState(false);

  // Callback para actualizar el estado de precarga
  const callbackPrecarga = () => {
    setPrecargaLoaded(true);
  };

  // Efecto para cambiar el fondo del body según el tema
  useEffect(() => {
    const rootDiv = document.body;
    if (rootDiv) {
      rootDiv.style.background = theme.colors.background;
    }
  }, [theme.colors.background]);

  useEffect(() => {
    setPrecargaLoaded(false);
  }, [currentLanguage]);

  return (
    <>
      <Loading />
      <BrowserRouter /* basename='/portal' */>
        {!precargaLoaded ? (
          <Precarga callback={callbackPrecarga} />
        ) : (
          <>
            <header className='navbar-wrapper-fixed'>
              <div className='top-border' />
              <PriorityMessageAlert />
              <div className='router-container'>
                <NavBar />
              </div>
            </header>
            <div className='router-container'>
              {showSubMenuSelector ? <SubMenu /> : null}
              <Router precargaLoaded={precargaLoaded} />
              <LeftMenu />
              {/* <BannerCookies /> */}
            </div>
          </>
        )}
        <Footer />
      </BrowserRouter>
    </>
  );
}
